import { Dispatch, SetStateAction } from 'react';
import check from '../../../../assets/images/icons/check.svg';
import exclamation from '../../../../assets/images/icons/exclamation.svg';
import { Card } from '../../../../components/Lists';
import MyModal from '../../../../components/Modal';
import formatCurrency from '../../../../utils/formatCurrency';
import hideCpf from '../../../../utils/hideCpf';
import { MappedPassengerType } from '../types';

interface InfoModalInterface {
  passengerInfo: MappedPassengerType;
  infoModalShow: boolean;
  setInfoModalShow: Dispatch<SetStateAction<boolean>>;
}

export default function InfoModal({ passengerInfo, infoModalShow, setInfoModalShow }: InfoModalInterface) {
  return (
    <MyModal
      show={infoModalShow}
      title={`Detalhes do passageiro ${passengerInfo.name}`}
      modalBody={(
        <Card>
          <div className="info">
            <div className="card-title">
              <strong>{passengerInfo.name}</strong>
              {passengerInfo.status === 'Ativo'
                ? <small className="green">Ativo</small>
                : (
                  <small className="orange">
                    {passengerInfo.inactiveDate
                      ? `Inativo até ${new Date(passengerInfo.inactiveDate?.replace(/-/g, '\/')).toLocaleDateString()}`
                      : 'Inativo'}
                  </small>
                )}
            </div>
            <span>
              {passengerInfo.vtValue == 0
                ? <>Não usa VT</>
                : formatCurrency(String(passengerInfo.vtValue))}
            </span>
            <span>
              <div>
                <strong>Ida:</strong>
                {' '}
                {passengerInfo.goingLine?.replace('.kml', '').toLowerCase()}
              </div>
              {passengerInfo.goingLineStatus === 'Titular'
                ? <img src={check} alt="Titular" />
                : (
                  <img src={exclamation} alt="Perdeu a titularidade" />
                )}
            </span>
            <span>
              <div>
                <strong>Volta:</strong>
                {' '}
                {passengerInfo.backLine?.replace('.kml', '').toLowerCase()}
              </div>
              {passengerInfo.backLineStatus === 'Titular'
                ? <img src={check} alt="titular" />
                : (
                  <img src={exclamation} alt="perdeu titularidade" />
                )}
            </span>
            <span>
              <div>
                <strong>CPF:</strong>
                {hideCpf(passengerInfo.cpf)}
              </div>
            </span>
            <span>
              <div>
                <strong>Matrícula:</strong>
                {passengerInfo.registration ? passengerInfo.registration : 'Não cadastrada'}
              </div>
            </span>
            <span>
              <div>
                <strong>Horário:</strong>
                {`Das ${passengerInfo.entryTime} às ${passengerInfo.exitTime}`}
              </div>
            </span>
            <span>
              <div>
                <strong>Endereço:</strong>
                {`${passengerInfo.streetName}, ${passengerInfo.number} - ${passengerInfo.district}`}
              </div>
            </span>
            <span>
              <div>
                {`${passengerInfo.city}, ${passengerInfo.uf}`}
              </div>
            </span>
          </div>
        </Card>
      )}
      closeButtonLabel="Fechar"
      onClose={() => {
        setInfoModalShow(false);
      }}
      size='lg'
      type="info"
    />
  );
}
